import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { INSPIRATION_SCENARIO_LABELS } from "web_myplann/Inspiration/constants";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import {
	getEarlyFreedomScenario,
	getEarlyFreedomScenarioRatePercent,
} from "web_myplann/Inspiration/EarlyFreedom/Utils/earlyFreedomMath";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.EarlyFreedom;

export const useEarlyFreedomAdvisorMessage = () => {
	const { t } = useResource();

	return (context: EarlyFreedomContext) => {
		if (context.isEarlyFreedomReady)
			return t(R.advisorMessageReady, {
				targetExpenses: formatInspirationMoney(context.targetExpenses),
				passiveIncome: formatInspirationMoney(context.passiveToday),
				coverage: context.coverageRatio,
			});

		const scenario = getEarlyFreedomScenario(context, context.selectedScenario);

		return t(R.advisorMessage, {
			targetIncome: formatInspirationMoney(context.gap),
			targetCapital: formatInspirationMoney(context.targetCapital),
			monthlySaving: formatInspirationMoney(context.monthlySaving),
			scenario: t(INSPIRATION_SCENARIO_LABELS[context.selectedScenario]),
			rate: getEarlyFreedomScenarioRatePercent(scenario),
		});
	};
};
